// Copyright © 2025 CATTLEytics Inc.

import React from 'react';
import { FaUserLarge } from 'react-icons/fa6';

interface Props {
  nUsers: number;
  size?: number | string;
}

const MultiUserBadge: React.FC<Props> = ({ nUsers, size }) => {
  if (nUsers < 2) {
    return null;
  }

  return (
    <div style={{ display: 'inline-block', position: 'relative', fontSize: size }}>
      <FaUserLarge style={{ display: 'inline', color: 'inherit' }} />
      <span
        style={{
          color: 'white',
          background: 'var(--bs-gray)',
          position: 'absolute',
          top: '-0.4em',
          right: '-0.8em',
          fontSize: '0.8em',
          height: '1em',
          width: '1em',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <span>{nUsers}</span>
      </span>
    </div>
  );
};

export default MultiUserBadge;
